import { setupDynamicArgsFunction } from "../../configuration/interface"
import { createTimestamp } from '../util/createTimestamp'

const parseCommitTimestamp = (rawTimestamp: string): Date => {
  if (/^\d+$/.test(rawTimestamp)) {
    return new Date(parseInt(rawTimestamp, 10) * 1000)
  }
  return new Date(rawTimestamp)
}

export const setupDynamicArgs: setupDynamicArgsFunction = async (deployConfig, environmentConfig, serverConfig, dynamicArgs, ssh) => {
  const sha = process.env.CI_COMMIT_SHORT_SHA
  const commitDate = parseCommitTimestamp(process.env.CI_TOOLS_COMMIT_TIMESTAMP)
  const timestamp = createTimestamp(commitDate)
  const { getAppName } = serverConfig
  const appName = await getAppName(deployConfig, environmentConfig, serverConfig, dynamicArgs, ssh)
  const buildPath = `${environmentConfig.uploadConfig.uploadTo}/${appName}/${timestamp}.${sha}`

  dynamicArgs.commitDate = commitDate
  dynamicArgs.buildPath = buildPath
}